<template>
  <div class="wonderfulReview">
    <div class="zxzx_div">
      <el-menu
        :default-active="activeIndex"
        :default-openeds="openedIndex"
        active-text-color="#143372"
		:router="true"
      >
        <el-menu-item  class="title" index="/wonderfulReview">
          <span slot="title">精彩回顾</span>
        </el-menu-item>
        <!-- <el-menu-item index="/wonderfulReview/exhibitorScene">
          <span slot="title">展会现场</span>
        </el-menu-item>
        <el-menu-item index="/wonderfulReview/forumSite">
          <span slot="title">论坛现场</span>
        </el-menu-item> -->
		
		<el-submenu v-for="(item, i) in scheduleList" :key="String(item.id)" :index="String(item.id)" >
		   <template slot="title">
		     <span>{{item.nameAbbreviation}}</span>
		   </template>
		   <el-menu-item :index="String(item.id)+'-1'"  :route="{ path: '/wonderfulReview/wRNoticeInfo', query: {code: item.id,name:item.nameAbbreviation } }" class="child">展会动态</el-menu-item>
		   <el-menu-item :index="String(item.id)+'-2'"  :route="{ path: '/wonderfulReview/wREventsInfo', query: {code: item.id,name:item.nameAbbreviation } }" class="child">行业资讯</el-menu-item>
		   <el-menu-item :index="String(item.id)+'-3'"  :route="{ path: '/wonderfulReview/wRIndustryInfo', query: {code: item.id,name:item.nameAbbreviation } }" class="child">名企风采</el-menu-item>
		   <el-menu-item :index="String(item.id)+'-4'"  :route="{ path: '/wonderfulReview/wRForumIntroduction', query: {code: item.id,name:item.nameAbbreviation } }" class="child">会议论坛</el-menu-item>
		 </el-submenu> 
      </el-menu>
    </div>
    <div class="right_content">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
export default {
  name: "wonderfulReview", // 资讯中心
  components: {
  },
  data() {
    return {
      tabName: "",
      dataList: [],
	  scheduleList: [],
      routePath: "",
	  activeIndex:"",
	  openedIndex:[],
	  firstId:"",
	  firstName:"",
	  
    };
  },
  computed: {
  },
  watch: {
    $route(to, from) {
		if(to.path.indexOf('/wonderfulReview') !=-1){
			this.setCurrentRoute();
		}else{//要清空相关的内容
			sessionStorage.setItem( "wonderfulReviewMenu",  JSON.stringify({ defaultActive: "", leaveOpen: [] }));
			this.activeIndex = "";
			this.openedIndex = [];
		}
    },
  },
  created() {
  },
  activated() {
	if(this.activeIndex === ""){//每次点击精彩回顾， this.activeIndex都应该是空；需要重新构建左侧菜单
		 this.getScheduleHistoryList();
	}
  },
  mounted() {
  },
  methods: {
	 getScheduleHistoryList() {
	   this.$http({
	     url: "schedule/getScheduleHistoryList",
	     method: "post",
	     params: {
	     },
	   })
	     .then(({ data }) => {
	       let { code, scheduleHistoryList } = data;
	       if (code === 0) {
			  this.scheduleList = scheduleHistoryList;
			  this.firstId = scheduleHistoryList[0].id.toString();
			  this.firstName = scheduleHistoryList[0].nameAbbreviation.toLocaleString();
			  this.setCurrentRoute();
			  let sessionStore = JSON.parse(sessionStorage.getItem("wonderfulReviewMenu"));
			  this.activeIndex = sessionStore.defaultActive;
			  this.openedIndex = sessionStore.defaultOpen;
	       }
	     })
	     .catch((err) => console.log(err));
	 }, 
	 
	 setCurrentRoute() {
		 let active1 = "";
		 let open1 = [];
		 // console.log(this.$route.path+"--------$route.path");
		 if(this.$route.path === "/wonderfulReview/wRNoticeInfo"){
		 	active1 = this.$route.query.code.toString()+"-1";
			open1.push(this.$route.query.code);
		 }else if(this.$route.path === "/wonderfulReview/wREventsInfo"){
		  	active1 = this.$route.query.code.toString()+"-2";
			open1.push(this.$route.query.code);
		}else if(this.$route.path === "/wonderfulReview/wRIndustryInfo"){
		  	active1 = this.$route.query.code.toString()+"-3";
			open1.push(this.$route.query.code);
		}else if(this.$route.path === "/wonderfulReview/wRForumIntroduction"){
		  	active1 = this.$route.query.code.toString()+"-4";
			open1.push(this.$route.query.code);
		}else{
			active1 = this.firstId+"-1";
			open1.push(this.firstId);
		}
		
		//sessionStorage， 每次刷新F5 值不丢失， 左侧还可选中
		sessionStorage.setItem( "wonderfulReviewMenu",  JSON.stringify({ defaultActive: active1, defaultOpen: open1 }));
		// let sessionStore = JSON.parse(sessionStorage.getItem("wonderfulReviewMenu"));
		// console.log(sessionStore.defaultActive+"---------defaultActive");
		// console.log(sessionStore.defaultOpen+"--------defaultOpen");
	 },
  },
}; 
</script>

<style lang="scss">
.wonderfulReview {
  .zxzx_ul {
    //height: 500px;
    .el-collapse-item__content {
      padding: 0;
    }
    .el-collapse-item__header {
      height: 64px;
      color: #999999;
      font-weight: bold;
      border-bottom: 1px dashed #f2f2f2;
      line-height: 64px;
      text-indent: 31px;
      font-size: 16px;
    }
    .el-collapse-item__wrap {
      border-bottom: 1px dashed #f2f2f2;
    }
    .el-collapse-item__arrow {
      font-size: 14px;
      width: 14px;
      color: #143277;
      margin: 0 24px 0 auto;
    }
    .el-icon-arrow-right:before {
      content: "\e791";
      margin-left: -31px;
    }
    .el-collapse-item__header.is-active {
      // color: #143277;
    }
  }
  .el-menu-item {
    padding-left: 0 !important;
    color: #999999;
    font-weight: bold;
    width: 238px;
    height: 64px;
    line-height: 64px;
    text-indent: 31px;
    font-size: 16px;
   // border-bottom: 1px dashed #f2f2f2;
    &:hover,
    &:focus {
      background-color: #ffffff;
    }
  }
  .el-submenu__title {
    height: 64px;
    line-height: 64px;
    border-bottom: 1px dashed #f2f2f2;
    padding-left: 31px !important;
    span {
      color: #999999;
      font-weight: bold;
      font-size: 16px;
    }
    &:hover,
    &:focus {
      background-color: #ffffff;
    }
  }

  .el-icon-arrow-down:before {
    content: "\e791";
    color: rgb(20, 50, 119);
  }
  .el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
    transform: rotateZ(90deg) !important;
  }
  .el-submenu.is-active .el-submenu__title {
    border-bottom-color: #f2f2f2 !important;
  }
}
</style>
<style lang="scss" scoped>
.wonderfulReview {
  .liActive {
    color: #143372 !important;
  }
  .zxzx_div {
    width: 238px;
    //min-height: 256px;
	height: 100%;
    border-right: 1px solid #4bbc81;
    border-bottom: 1px solid #4bbc81;
    border-left: 1px solid #02b3ea;
    float: left;
    .title {
      font-size: 24px;
      font-weight: normal;
      color: #fff;
      cursor: default;
      background-image: linear-gradient(to right, #02b3ea, #4bbc81);
      border-bottom: none;
    }
    .child {
      font-size: 14px;
      text-indent: 54px;
    }
  }
  .right_content {
    width: 936px;
    float: right;
  }
}
</style>